var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo, } from "react";
import { useBlockContext, useChildrenBlocks } from "./BlockEngineApi.js";
export const FrontendChildrenBlock = forwardRef(function ChildrenBlockRenderer(_a, ref) {
    var { gutenbergEditorConfig, childrenProps, childrenBlockComponent } = _a, props = __rest(_a, ["gutenbergEditorConfig", "childrenProps", "childrenBlockComponent"]);
    const blockContext = useBlockContext();
    const ChildrenBlockComponent = childrenBlockComponent !== null && childrenBlockComponent !== void 0 ? childrenBlockComponent : blockContext === null || blockContext === void 0 ? void 0 : blockContext.childrenBlockRenderer;
    const childrenContext = useMemo(() => ({
        parentBlock: blockContext,
        childrenProps: childrenProps,
    }), [blockContext, props]);
    return React.createElement(ChildrenBlockContext.Provider, {
        key: "children-block-context-" + (blockContext === null || blockContext === void 0 ? void 0 : blockContext.id),
        value: childrenContext,
    }, React.createElement(SmartfireChildrenBlocks, Object.assign(Object.assign({}, props), { childrenBlockComponent: ChildrenBlockComponent, ref })));
});
const SmartfireChildrenBlocks = forwardRef(function SmartfireInnerBlocks(_a, ref) {
    var { childrenBlockComponent, gutenbergEditorConfig } = _a, props = __rest(_a, ["childrenBlockComponent", "gutenbergEditorConfig"]);
    const blockContext = useBlockContext();
    const type = childrenBlockComponent !== null && childrenBlockComponent !== void 0 ? childrenBlockComponent : "div";
    return React.createElement(type, Object.assign(Object.assign({}, props), { ref }), blockContext === null || blockContext === void 0 ? void 0 : blockContext.children);
});
export const ChildrenBlock = forwardRef(function (props, ref) {
    const { Children } = useChildrenBlocks();
    return React.createElement(Children, Object.assign(Object.assign({}, props), { ref }));
});
export const ChildrenBlockContext = React.createContext(undefined);

//# sourceMappingURL=ChildrenBlock.js.map
